export default {
  install: (app, options) => {
    const { context } = options || {};
    const i18n = context ? window.setTranslationContext(context) : window.t

    app.config.globalProperties.$i18n = i18n.t.bind(i18n)
  }
}